module.exports = __webpack_public_path__ + "img/group2_03_1.3cc723a0.png";